import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Cliente/imprimirCliente`, method: 'POST', body: list, token: token})
}